export const RATING_VALUE_PLACEHOLDER = '-';

type RatingLike =
  | {
      count?: number;
      score?: string;
    }
  | undefined;

export function hasRatingReviews(rating: RatingLike): boolean {
  return typeof rating?.count === 'number' && rating.count > 0;
}

export function resolveRatingValueLabel(
  rating: RatingLike,
  fallbackValue = RATING_VALUE_PLACEHOLDER,
): string {
  if (!hasRatingReviews(rating)) {
    return fallbackValue;
  }

  const ratingScore =
    typeof rating?.score === 'string' ? rating.score.trim() : '';

  return ratingScore.length > 0 ? ratingScore : fallbackValue;
}
